var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 12.8125V19.5625M27.4 9.4375V16.1875M25.75 1C29.7904 1 31.9757 1.63241 33.063 2.12293C33.2078 2.18826 33.2802 2.22092 33.4892 2.42488C33.6144 2.54713 33.8431 2.90585 33.9019 3.0724C34 3.35025 34 3.50212 34 3.80588V21.9438C34 23.4774 34 24.2441 33.7751 24.6383C33.5464 25.0392 33.3258 25.2256 32.8977 25.3796C32.4768 25.5311 31.6272 25.3642 29.9281 25.0303C28.7388 24.7966 27.3283 24.625 25.75 24.625C20.8 24.625 15.85 28 9.25 28C5.20963 28 3.02433 27.3676 1.93701 26.8771C1.7922 26.8117 1.7198 26.7791 1.51084 26.5751C1.38558 26.4529 1.15694 26.0941 1.09813 25.9276C1 25.6498 1 25.4979 1 25.1941L1 7.05619C1 5.52265 1 4.75587 1.22486 4.36174C1.45359 3.96083 1.67417 3.77445 2.1023 3.62037C2.52318 3.4689 3.37276 3.63585 5.07192 3.96974C6.26122 4.20345 7.67174 4.375 9.25 4.375C14.2 4.375 19.15 1 25.75 1ZM21.625 14.5C21.625 16.83 19.7782 18.7187 17.5 18.7187C15.2218 18.7187 13.375 16.83 13.375 14.5C13.375 12.17 15.2218 10.2812 17.5 10.2812C19.7782 10.2812 21.625 12.17 21.625 14.5Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney2);
export default __webpack_public_path__ + "static/media/money_2.2d5a9e6727ae1b25f4531f1b98418a9b.svg";
export { ForwardRef as ReactComponent };